import { useCallback, useEffect, useMemo, useState } from "react";

const rowKey = person => {
  if (person._type === "unit") return `unit:${person.rental_id || person.id}`;
  if (person._type === "guest") return `guest:${person.guest_id || person.crm_identity_id || person.id}`;
  return `contact:${person.contact_id || person.id}`;
};
const categoryOf = person => person._type === "unit" ? "unit"
  : person._type === "guest" ? "guest" : person.category === "lead" ? "leads" : person.category;

export default function useContactSelection(list, category, accountId) {
  const [selection, setSelection] = useState({ accountId, rows: new Map() });
  useEffect(() => {
    setSelection(previous => previous.accountId === accountId ? previous : { accountId, rows: new Map() });
  }, [accountId]);
  const rows = useMemo(() => selection.accountId === accountId ? selection.rows : new Map(), [selection, accountId]);
  const selectedFlags = useMemo(() => list.map(person => categoryOf(person) === category && rows.has(rowKey(person))), [list, category, rows]);
  const selectedContacts = useMemo(() => list.filter((_, index) => selectedFlags[index]), [list, selectedFlags]);
  const mergePeople = useMemo(() => [...rows.values()].filter(person => person._type !== "unit" && person.crm_identity_id), [rows]);

  const select = useCallback((people, checked) => {
    setSelection(previous => {
      const next = new Map(previous.accountId === accountId ? previous.rows : []);
      people.filter(person => categoryOf(person) === category).forEach(person => {
        if (checked) next.set(rowKey(person), person);
        else next.delete(rowKey(person));
      });
      return { accountId, rows: next };
    });
  }, [accountId, category]);
  const clear = useCallback(() => setSelection({ accountId, rows: new Map() }), [accountId]);

  return { selectedFlags, selectedContacts, mergePeople, select, clear };
}
